<template>
    <div class="flex flex-col h-screen-index">
        <!-- 头部导航 -->
        <div class="flex flex-col justify-between p-4">
            <div class="flex items-center space-x-4">
                <div class="tabs tabs-boxed">
                    <a :class="{ 'tab': true, 'tab-active': tabSelect2 === 'log' }" @click="handleTab2('log')">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        操作日志
                    </a>
                    <a :class="{ 'tab': true, 'tab-active': tabSelect2 === 'runtime' }" @click="handleTab2('runtime')">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                        </svg>
                        运行日志
                    </a>
                </div>
            </div>
        </div>
        <!-- 主要内容区域 -->
        <div class="flex flex-1 p-2">
            <!-- 操作日志内容 -->
            <div v-show="tabSelect2 === 'log'" class="flex-1 flex flex-col bg-base-100 rounded-xl shadow-lg max-h-full">
                <div class="md:px-4 pb-4">
                    <!-- 桌面端筛选器 -->
                    <div class="hidden md:flex items-center space-x-4">
                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm font-medium">操作类型</span>
                            </label>
                            <select class="select select-bordered select-sm w-48" v-model="tabSelect"
                                @change="handleFilterChange">
                                <option value="">全部操作</option>
                                <option value="手动修改">手动修改</option>
                                <option value="自动刮削">自动刮削</option>
                                <option value="后台刮削">后台刮削</option>
                                <option value="导入收藏">导入收藏</option>
                                <option value="重复检查">重复检查</option>
                                <option value="删除空文件夹">删除空文件夹</option>
                            </select>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm font-medium">日志等级</span>
                            </label>
                            <select class="select select-bordered select-sm w-32" v-model="levelFilter"
                                @change="handleFilterChange">
                                <option value="">全部等级</option>
                                <option value="info">信息</option>
                                <option value="warning">警告</option>
                                <option value="error">错误</option>
                            </select>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm font-medium">状态</span>
                            </label>
                            <select class="select select-bordered select-sm w-32" v-model="statusFilter"
                                @change="handleFilterChange">
                                <option value="">全部状态</option>
                                <option value="running">进行中</option>
                                <option value="success">成功</option>
                                <option value="stop">停止</option>
                            </select>
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm font-medium">用户</span>
                            </label>
                            <input type="text" class="input input-bordered input-sm w-32" placeholder="搜索用户"
                                v-model="userFilter" @input="handleFilterChange">
                        </div>

                        <div class="form-control">
                            <label class="label">
                                <span class="label-text text-sm font-medium">&nbsp;</span>
                            </label>
                            <button class="btn btn-outline btn-sm" @click="resetFilters">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                                重置
                            </button>
                        </div>
                    </div>

                    <!-- 移动端筛选器 -->
                    <div class="md:hidden space-y-3">
                        <!-- 第一行：操作类型和重置按钮 -->
                        <div class="flex space-x-2">
                            <div class="form-control flex-1">
                                <select class="select select-bordered select-sm" v-model="tabSelect"
                                    @change="handleFilterChange">
                                    <option value="">全部操作</option>
                                    <option value="手动修改">手动修改</option>
                                    <option value="自动刮削">自动刮削</option>
                                    <option value="后台刮削">后台刮削</option>
                                    <option value="导入收藏">导入收藏</option>
                                    <option value="重复检查">重复检查</option>
                                    <option value="删除空文件夹">删除空文件夹</option>
                                </select>
                            </div>
                            <button class="btn btn-outline btn-sm px-2" @click="resetFilters">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                </svg>
                            </button>
                        </div>
                        <!-- 第二行：等级、状态、用户 -->
                        <div class="flex space-x-2">
                            <div class="form-control flex-1">
                                <select class="select select-bordered select-sm" v-model="levelFilter"
                                    @change="handleFilterChange">
                                    <option value="">全部等级</option>
                                    <option value="info">信息</option>
                                    <option value="warning">警告</option>
                                    <option value="error">错误</option>
                                </select>
                            </div>
                            <div class="form-control flex-1">
                                <select class="select select-bordered select-sm" v-model="statusFilter"
                                    @change="handleFilterChange">
                                    <option value="">全部状态</option>
                                    <option value="running">进行中</option>
                                    <option value="success">成功</option>
                                    <option value="stop">停止</option>
                                </select>
                            </div>
                            <div class="form-control flex-1 !hidden md:!block">
                                <input type="text" class="input input-bordered input-sm" placeholder="用户"
                                    v-model="userFilter" @input="handleFilterChange">
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 日志内容 -->
                <div class="flex-1 overflow-auto bg-base-100">
                    <!-- 桌面端表格视图 -->
                    <div class="hidden md:block" style="min-height: 0; max-height: calc(100vh - 300px);">
                        <table class="table table-zebra w-full">
                            <thead class="sticky top-0 bg-base-200 z-10">
                                <tr>
                                    <th class="font-semibold">ID</th>
                                    <th class="font-semibold">用户</th>
                                    <th class="font-semibold">操作</th>
                                    <th class="font-semibold">等级</th>
                                    <th class="font-semibold">状态</th>
                                    <th class="font-semibold">详情</th>
                                    <th class="font-semibold">时间</th>
                                    <th class="font-semibold">操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in auditLogData" :key="index"
                                    class="hover:bg-base-200/50 transition-colors duration-200">
                                    <td class="font-mono text-sm">#{{ item.id }}</td>
                                    <td class="font-medium">
                                        <div class="flex items-center">
                                            <div class="avatar placeholder mr-2">
                                                <div class="bg-primary text-primary-content rounded-full w-8 h-8">
                                                    <span class="text-xs">{{ item.user.charAt(0).toUpperCase() }}</span>
                                                </div>
                                            </div>
                                            {{ item.user }}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="badge badge-outline">{{ item.action }}</div>
                                    </td>
                                    <td>
                                        <div :class="[
                                            'badge badge-sm',
                                            item.level === 'info' ? 'badge-ghost' :
                                                item.level === 'error' ? 'badge-error' :
                                                    'badge-warning'
                                        ]">
                                            {{ item.level }}
                                        </div>
                                    </td>
                                    <td>
                                        <div :class="['badge badge-sm gap-1', getStatusClass(item.status)]">
                                            <div v-if="item.status === 'running'"
                                                class="w-1.5 h-1.5 rounded-full bg-current animate-ping"></div>
                                            <div v-else class="w-1.5 h-1.5 rounded-full bg-current text-white"></div>
                                            <div class="text-white text-xs">
                                                {{ getStatusText(item.status) }}
                                            </div>
                                        </div>
                                    </td>
                                    <td class="max-w-md">
                                        <div class="tooltip tooltip-bottom" :data-tip="item.extra" v-if="item.extra">
                                            <div class="text-sm text-base-content/80 truncate max-w-48">
                                                {{ item.extra }}
                                            </div>
                                        </div>
                                        <span v-else class="text-base-content/50 text-sm">-</span>
                                    </td>
                                    <td class="font-mono text-xs text-base-content/70 whitespace-nowrap">
                                        {{ item.created_at }}
                                    </td>
                                    <td>
                                        <div v-if="hasLogDetail.indexOf(item.action) !== -1"
                                            class="dropdown dropdown-end">
                                            <a @click="handleRedirect(item)"
                                                class="flex items-center cursor-pointer text-primary hover:text-neutral">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-1" fill="none"
                                                    viewBox="0 0 24 24" stroke="currentColor">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        stroke-width="2"
                                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                            </a>
                                        </div>
                                        <span v-else class="text-base-content/30">-</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- 移动端卡片视图 -->
                    <div class="md:hidden px-2 space-y-3 pb-4" style="min-height: 0; max-height: calc(100vh - 350px);">
                        <div v-for="(item, index) in auditLogData" :key="index"
                            class="bg-base-200 rounded-lg p-4 space-y-3 shadow-sm border border-base-300">
                            <!-- 头部：ID、用户、时间 -->
                            <div class="flex items-center justify-between">
                                <div class="flex items-center space-x-2">
                                    <div class="font-mono text-xs bg-base-300 px-2 py-1 rounded">#{{ item.id }}</div>
                                    <div class="flex items-center space-x-1">
                                        <div class="avatar placeholder">
                                            <div class="bg-primary text-primary-content rounded-full w-6 h-6">
                                                <span class="text-xs">{{ item.user.charAt(0).toUpperCase() }}</span>
                                            </div>
                                        </div>
                                        <span class="text-sm font-medium">{{ item.user }}</span>
                                    </div>
                                </div>
                                <div class="text-xs text-base-content/60">
                                    {{ item.created_at.split(' ')[1] }}
                                </div>
                            </div>

                            <!-- 操作和状态 -->
                            <div class="flex items-center justify-between">
                                <div class="badge badge-outline text-xs">{{ item.action }}</div>
                                <div class="flex items-center space-x-2">
                                    <!-- 等级 -->
                                    <div :class="[
                                        'badge badge-xs',
                                        item.level === 'info' ? 'badge-ghost' :
                                            item.level === 'error' ? 'badge-error' :
                                                'badge-warning'
                                    ]">
                                        {{ item.level }}
                                    </div>
                                    <!-- 状态 -->
                                    <div :class="[
                                        'badge badge-xs gap-1',
                                        item.status === 'running' ? 'badge-info' :
                                            item.status === 'success' ? 'badge-success' :
                                                item.status === 'stop' ? 'badge-warning' : 'badge-ghost'
                                    ]">
                                        <div v-if="item.status === 'running'"
                                            class="w-1 h-1 rounded-full bg-current animate-ping"></div>
                                        <div v-else class="w-1 h-1 rounded-full bg-current"></div>
                                        <span class="text-xs">
                                            {{ item.status === 'running' ? '进行中' :
                                                item.status === 'success' ? '成功' :
                                                    item.status === 'stop' ? '停止' : item.status }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- 详情和操作 -->
                            <div class="flex items-center justify-between">
                                <div class="flex-1 pr-2">
                                    <div v-if="item.extra" class="text-xs text-base-content/70 truncate max-w-48" :title="item.extra">
                                        {{ item.extra }}
                                    </div>
                                    <span v-else class="text-base-content/50 text-xs">无详情</span>
                                </div>
                                <div v-if="hasLogDetail.indexOf(item.action) !== -1">
                                    <button @click="handleRedirect(item)" class="btn btn-xs btn-ghost text-primary">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 空状态 -->
                    <div v-if="auditLogData.length === 0" class="text-center py-12">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-base-content/30"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <h3 class="text-lg font-medium text-base-content/70 mt-4">暂无操作日志</h3>
                        <p class="text-base-content/50 mt-2">当前筛选条件下没有找到相关日志记录</p>
                    </div>
                </div>

                <!-- 分页 - 移动端优化 -->
                <div v-if="auditLogData.length > 0" class="px-4 py-2 bg-base-50">
                    <!-- 桌面端分页 -->
                    <div class="hidden md:flex justify-between items-center">
                        <div class="text-sm text-base-content/70">
                            共 <span class="font-semibold">{{ totalRecords }}</span> 条记录，第 <span class="font-semibold">{{
                                currentPage }}</span> 页
                        </div>
                        <div class="join">
                            <button class="join-item btn btn-sm" :disabled="currentPage === 1"
                                @click="handlePageChange(currentPage - 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button class="join-item btn btn-sm btn-active">
                                {{ currentPage }}
                            </button>
                            <button class="join-item btn btn-sm" :disabled="!hasNextPage"
                                @click="handlePageChange(currentPage + 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                            <input type="number" class="join-item input input-bordered input-sm w-20" v-model="jumpPage"
                                min="1" placeholder="页码" />
                            <button class="join-item btn btn-primary btn-sm"
                                @click="handlePageChange(Number(jumpPage))">
                                跳转
                            </button>
                        </div>
                    </div>

                    <!-- 移动端分页 -->
                    <div class="md:hidden">
                        <!-- 记录信息 -->
                        <div class="text-xs text-base-content/70 text-center mb-3">
                            第 {{ currentPage }} 页，共 {{ totalRecords }} 条
                        </div>
                        <!-- 分页控制 -->
                        <div class="flex items-center justify-center space-x-2">
                            <button class="btn btn-xs btn-circle" :disabled="currentPage === 1"
                                @click="handlePageChange(currentPage - 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <input type="number" class="input input-bordered input-xs w-16 text-center text-xs"
                                v-model="jumpPage" min="1" placeholder="页" />
                            <button class="btn btn-primary btn-xs" @click="handlePageChange(Number(jumpPage))">
                                跳转
                            </button>
                            <button class="btn btn-xs btn-circle" :disabled="!hasNextPage"
                                @click="handlePageChange(currentPage + 1)">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 运行日志内容 -->
            <div v-show="tabSelect2 === 'runtime'" class="flex-1 flex flex-col">
                <div class="flex items-center justify-between">
                    <!-- 服务类型选择 -->
                    <div class="px-4 pb-4 border-b border-base-300 bg-base-50">
                        <div class="form-control w-40">
                            <label class="label">
                                <span class="label-text font-medium">服务类型</span>
                            </label>
                            <select class="select select-bordered" v-model="tabSelectRuntime"
                                @change="handleRuntimeFilterChange">
                                <option value="gunicorn">Gunicorn</option>
                                <option value="worker">Worker</option>
                                <option value="beat">Beat</option>
                                <option value="redis">Redis</option>
                                <option value="xiaoai">Xiaoai</option>
                            </select>
                        </div>
                    </div>
                    <!-- 轮询配置 -->
                    <div class="flex items-center space-x-2" v-if="tabSelect2 === 'runtime'">
                        <!-- 轮询间隔控制 -->
                        <div class="flex items-center space-x-1 text-sm">
                            <input type="number" class="input input-bordered input-sm w-12 sm:w-16"
                                v-model="pollInterval" min="1" max="60">
                            <span class="text-base-content/70 hidden sm:inline">秒</span>
                            <span class="text-base-content/70 sm:hidden text-xs">s</span>
                        </div>

                        <!-- 开始/停止按钮 - 移动端优化 -->
                        <button :class="['btn btn-sm', isPolling ? 'btn-error' : 'btn-success']" @click="togglePolling">
                            <svg v-if="isPolling" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span class="hidden sm:inline">{{ isPolling ? '停止' : '开始' }}</span>
                        </button>

                        <!-- 反馈日志按钮 - 移动端优化 -->
                        <button class="btn btn-outline btn-sm" onclick="download_log.showModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                            </svg>
                            <span class="hidden sm:inline ml-1">反馈日志</span>
                        </button>
                    </div>
                </div>
                <!-- 日志显示区域 -->
                <div class="flex-1 flex flex-col lg:flex-row overflow-hidden">
                    <!-- 运行日志 -->
                    <div class="flex-1 flex flex-col border-r border-base-300">
                        <div class="p-3 bg-success/10 border-b border-base-300">
                            <h3 class="font-semibold text-success flex items-center">
                                <div class="w-2 h-2 rounded-full bg-success mr-2"></div>
                                运行日志
                            </h3>
                        </div>
                        <div class="flex-1 p-4">
                            <textarea ref="logTextarea"
                                class="textarea textarea-bordered w-full h-full font-mono text-sm resize-none"
                                placeholder="等待运行日志..." v-model="runtimeText" readonly>
                            </textarea>
                        </div>
                    </div>

                    <!-- 错误日志 -->
                    <div class="flex-1 flex flex-col">
                        <div class="p-3 bg-error/10 border-b border-base-300">
                            <h3 class="font-semibold text-error flex items-center">
                                <div class="w-2 h-2 rounded-full bg-error mr-2"></div>
                                错误日志
                            </h3>
                        </div>
                        <div class="flex-1 p-4">
                            <textarea ref="failLogTextarea"
                                class="textarea textarea-bordered w-full h-full font-mono text-sm resize-none"
                                placeholder="等待错误日志..." v-model="runtimeTextFail" readonly>
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 反馈日志模态框 -->
        <dialog id="download_log" ref="download_log" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold mb-4">反馈日志</h3>
                <div class="form-control mb-4">
                    <label class="label">
                        <span class="label-text">反馈内容</span>
                    </label>
                    <textarea class="textarea textarea-bordered h-32" placeholder="请详细描述您遇到的问题，这将帮助开发者快速定位和解决问题（至少20字）"
                        v-model="reason">
                    </textarea>
                </div>
                <div class="alert alert-info mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span class="text-sm">系统会同时上传相关日志文件给开发者进行分析</span>
                </div>
                <div class="modal-action">
                    <form method="dialog" class="flex space-x-2">
                        <button class="btn btn-primary" @click="handleUploadLog">
                            提交反馈
                        </button>
                        <button class="btn">取消</button>
                    </form>
                </div>
            </div>
            <form method="dialog" class="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            size: 'small',
            auditLogData: [],
            tabSelectRuntime: 'gunicorn',
            tabSelect2: 'log',
            runtimeText: '',
            runtimeTextFail: '',
            hasLogDetail: ['导入收藏', '自动刮削', '后台刮削', '重复检查', '手动修改', '整理文件夹', '刮削艺术家', '删除空文件夹', '拆分文本', '替换文本', '格式转换', '切割音轨', '乱码修复', '回放增益', '生成strm文件', '删除收藏'],
            pollInterval: 5,
            isPolling: true,
            pollingTimer: null,
            currentPage: 1,
            hasNextPage: true,
            jumpPage: 1,
            reason: '',
            totalRecords: 0,
            // 新增的筛选器
            levelFilter: '',
            statusFilter: '',
            userFilter: ''
        }
    },
    computed: {
        tabSelect: {
            get() {
                return this.$store.state.log.tabSelect
            },
            set(value) {
                this.$store.dispatch('log/setTabSelect', value)
            }
        }
    },
    created() {
        this.fetchAuditLog()
    },
    beforeDestroy() {
        this.stopPolling()
    },
    methods: {
        getStatusText(status) {
            const statusMap = {
                'running': '进行中',
                'success': '成功', 
                'stop': '停止',
                'failed': '失败'
            }
            return statusMap[status] || status
        },
        getStatusClass(status) {
            const classMap = {
                'running': 'badge-info',
                'success': 'badge-success',
                'stop': 'badge-warning',
                'failed': 'badge-error'
            }
            return classMap[status] || 'badge-ghost'
        },
        handlePageChange(page) {
            this.currentPage = page
            this.fetchAuditLog()
        },
        fetchAuditLog() {
            const params = {
                page: this.currentPage,
                page_size: 50,
                action: this.tabSelect
            }

            // 添加筛选参数
            if (this.levelFilter) params.level = this.levelFilter
            if (this.statusFilter) params.status = this.statusFilter
            if (this.userFilter) params.user = this.userFilter

            this.$api.Task.getAuditLog(params).then(res => {
                if (res.result) {
                    this.auditLogData = res.data.items
                    this.hasNextPage = res.data.count > this.currentPage * 50
                    this.totalRecords = res.data.count
                }
            })
        },
        fetchRuntimeLog() {
            this.$api.Task.getRuntimeLog({ type: this.tabSelectRuntime }).then(res => {
                if (res.result) {
                    this.runtimeText = res.data.log
                    this.runtimeTextFail = res.data.fail_log
                    this.$nextTick(() => {
                        if (this.$refs.logTextarea) {
                            this.$refs.logTextarea.scrollTop = this.$refs.logTextarea.scrollHeight
                        }
                        if (this.$refs.failLogTextarea) {
                            this.$refs.failLogTextarea.scrollTop = this.$refs.failLogTextarea.scrollHeight
                        }
                    })
                }
            })
        },
        handleTabInfo(v) {
            if (v === this.tabSelect) {
                this.tabSelect = ''
            } else {
                this.tabSelect = v
            }
            this.currentPage = 1
            this.fetchAuditLog()
        },
        handleFilterChange() {
            this.currentPage = 1
            this.fetchAuditLog()
        },
        handleRuntimeFilterChange() {
            this.fetchRuntimeLog()
        },
        resetFilters() {
            this.tabSelect = ''
            this.levelFilter = ''
            this.statusFilter = ''
            this.userFilter = ''
            this.currentPage = 1
            this.fetchAuditLog()
        },
        handleTab2(v) {
            this.tabSelect2 = v
            if (v === 'log') {
                this.stopPolling()
                this.currentPage = 1
                this.fetchAuditLog()
            } else {
                this.fetchRuntimeLog()
                if (this.isPolling) {
                    this.startPolling()
                }
            }
        },
        handleRuntimeTabInfo(v) {
            if (v === this.tabSelectRuntime) {
                this.tabSelectRuntime = ''
            } else {
                this.tabSelectRuntime = v
            }
            this.fetchRuntimeLog()
        },
        handleRedirect(item) {
            this.$router.push({ path: '/log_detail/' + item.id + '/' })
        },
        togglePolling() {
            if (this.isPolling) {
                this.stopPolling()
            } else {
                this.startPolling()
            }
        },
        startPolling() {
            this.isPolling = true
            this.fetchRuntimeLog()
            this.pollingTimer = setInterval(() => {
                this.fetchRuntimeLog()
            }, this.pollInterval * 1000)
        },
        stopPolling() {
            this.isPolling = false
            if (this.pollingTimer) {
                clearInterval(this.pollingTimer)
                this.pollingTimer = null
            }
        },
        handleUploadLog() {
            if (this.reason.length < 20) {
                this.$myMsg.notify({
                    title: '反馈失败！',
                    content: '反馈理由至少20字',
                    type: 'error',
                    time: 3000,
                })
                return
            }
            this.$api.Task.uploadLog({
                reason: this.reason
            }).then(res => {
                if (res.result) {
                    this.$refs["download_log"].close()
                    this.$myMsg.notify({
                        title: '反馈成功！',
                        type: 'success',
                        time: 3000,
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.h-screen-header {
    height: calc(100vh - 4rem);
}

/* 确保容器在不同环境下正确显示 */
.h-screen-index {
    height: calc(100vh - 70px);
    display: flex;
    flex-direction: column;
}

@media (max-width: 768px) {
    .h-screen-index {
        height: calc(100vh - 60px);
    }
}

/* 移动端卡片容器优化 */
@media (max-width: 768px) {
    .md\:hidden {
        max-height: calc(100vh - 200px);
        overflow-y: auto;
        padding-bottom: 1rem;
    }
}

/* 自定义滚动条 */
.textarea::-webkit-scrollbar,
.md\:hidden::-webkit-scrollbar {
    width: 6px;
}

.textarea::-webkit-scrollbar-track,
.md\:hidden::-webkit-scrollbar-track {
    background: transparent;
}

.textarea::-webkit-scrollbar-thumb,
.md\:hidden::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
}

.textarea::-webkit-scrollbar-thumb:hover,
.md\:hidden::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3);
}

/* 表格样式优化 */
.table th {
    background: hsl(var(--b2));
    position: sticky;
    top: 0;
    z-index: 10;
}

.table tbody tr:hover {
    background: hsl(var(--b2) / 0.5);
}

/* 工具提示样式 */
.tooltip:before {
    max-width: 300px;
    white-space: normal;
}

/* 确保卡片内容完整显示 */
.bg-base-200.rounded-lg {
    min-height: fit-content;
    overflow: visible;
    word-wrap: break-word;
}
</style>
